import React from "react";
import "./sectionOne.css";
import sectionOneSideImage from "../../../assets/image.png";
import { FaInstagram, FaCheckCircle } from "react-icons/fa";
import SectionSpacer from "../SectionSpacer/SectionSpacer";

const SectionOne = () => {
  return (
    <div className="vertical-container">
    
    {/* First Section: Text */}
      <div className="text-section">
        <div className="dm-automation-header">
          <FaInstagram className="icon-dm" aria-label="Instagram Icon" />
          <p>Instagram DM Automation </p>
        </div>
        <div className="caption-text-wrapper">
          {["Forever Free. No Free Trial.", "Limitless Customization."].map((text, index) => (
            <div className="dm-pointer" key={index}>
              <FaCheckCircle className="icon-pointer" aria-label="Check Icon" />
              <p>{text}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Second Section: Image */}
      <div>
        <img src={sectionOneSideImage} alt="DM Automation Example"  className="image-section" />
      </div>
    </div>
  );
};

export default SectionOne;
